export default __webpack_public_path__ + "static/media/bg.d9662f4e.jpg";